module.exports = __webpack_public_path__ + "img/sunglasses.12b8a9ce.svg";